import { IApplicationState } from '../../types/redux';
import { ENewAnswerModalStep } from '../../types/newAnswer';

export const getIsLastAnswerFormStep = (state: IApplicationState): boolean => {
  return state.newAnswer.meta.step !== ENewAnswerModalStep.Answer;
};
